var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "modal-content-mobileFull radius-18 bg-grey3 product-vitrine",
    },
    [
      _c(
        "div",
        { staticClass: "modal-top border-0 pos-sticky top-0 zindex-2 p-0" },
        [
          _c(
            "button",
            {
              staticClass: "close rounded-btn display-1 p-10 bg-grey3",
              attrs: { "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.modal.dismiss()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "font-lato text-light",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("×")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-main radius-18 bg-grey3 p-0" }, [
        _vm.cartItem.product.ims
          ? _c("div", { staticClass: "radius-18", attrs: { id: "bigImg" } }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cartItem.product.ims,
                    expression: "cartItem.product.ims",
                  },
                ],
                staticClass:
                  "prod-img img-fit img-fluid w-100 min-mt-60 radius-15 radius-bottom-0",
                attrs: {
                  src: _vm.UrlService.imagePath(
                    _vm.cartItem.product.ShopId,
                    _vm.cartItem.product.ims
                  ),
                },
                on: {
                  error: function ($event) {
                    $event.target.src = "dist/assets/no-img.png"
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "title display-2 color-grey1 zindex-1 text-bold radius-18 top-0 pos-sticky bg-grey3 pl-20 pr-40 py-20",
          },
          [_vm._v(_vm._s(_vm.product.dn))]
        ),
        _vm._v(" "),
        _vm.product.dd
          ? _c("p", {
              staticClass: "description display-5 color-grey6 px-20 mb-20",
              domProps: { innerHTML: _vm._s(_vm.product.dd) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.product.allergens.length || _vm.product.consumables.length
          ? _c(
              "div",
              { staticClass: "bg-white radius-4 p-20 m-20" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-between-center color-grey1 fsize-18 text-bold cursor-pointer hover-color1 w-100 text-uppercase",
                    on: {
                      click: function ($event) {
                        _vm.blockCollapsed = !_vm.blockCollapsed
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "flex-start-center w-100" }, [
                      _c("i", {
                        staticClass:
                          "fie-icon_warning-eat mr-10 fsize-24 text-normal",
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm.product.allergens.length > 1
                          ? _c("span", [_vm._v("Allergènes")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.allergens.length == 1
                          ? _c("span", [_vm._v("Allergène")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.allergens.length &&
                        _vm.product.consumables.length
                          ? _c("span", [_vm._v(" & ")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.consumables.length > 1
                          ? _c("span", [_vm._v("Consommables")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.product.consumables.length == 1
                          ? _c("span", [_vm._v("Consommable")])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("collapse-indicator", {
                      attrs: { open: !_vm.blockCollapsed },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.blockCollapsed,
                          expression: "!blockCollapsed",
                        },
                      ],
                    },
                    [_c("product-tags", { attrs: { product: _vm.product } })],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "modProdDescBox" }, [
          !_vm.ShopService.shop.info.display.hideMenuCompositionInVitrine &&
          _vm.cartItem.product.ty == 2 &&
          _vm.cartItem.product.categories.length
            ? _c(
                "div",
                {
                  staticClass:
                    "modProdDetails shadow-2 m-20 p-20 bg-white radius-5",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "fsize-18 text-uppercase text-bold color-grey1 mb-20",
                    },
                    [_vm._v("Ce qui est inclus")]
                  ),
                  _vm._v(" "),
                  _vm._l(
                    _vm.cartItem.product.categories,
                    function (category, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "row flex-start-center flex-wrap mt-10",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-4 col-md-4 col-lg-4 mb-10",
                            },
                            [
                              _c("div", { staticClass: "flex-start-center" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "circleNum radius-circle bg-grey3 color-2 flex-center-center mr-10",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fsize-18 no-line-height",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(category.ChoicesNumber) + "x"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-1 fsize-14 text-bold color-grey1",
                                  },
                                  [_vm._v(_vm._s(category.DefaultName))]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "detailsMenuCateg col-xs-12 col-sm-8 col-md-8 col-lg-8 mb-20 border-left-grey2",
                            },
                            _vm._l(category.menuCompos, function (compo, j) {
                              return _c(
                                "div",
                                { key: j, staticClass: "color-grey6 fsize-14" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(compo.product.dn) +
                                      "\n                            "
                                  ),
                                  _vm.compoPrice(compo, category)
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ShopService.prix(
                                              _vm.compoPrice(compo, category)
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cartItem.product.ty == 3 && _vm.freeOptionGroups.length
            ? _c(
                "div",
                {
                  staticClass:
                    "modProdDetails color-grey6 shadow-2 m-20 p-20 bg-white radius-5",
                },
                [
                  _c("div", { staticClass: "display-5 text-bold mb-5" }, [
                    _vm._v("Ce qui est inclus"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.freeOptionGroups, function (op, i) {
                      return _c("li", { key: i }, [
                        op.optionGroup.max != -1
                          ? _c("span", { staticClass: "qty" }, [
                              _vm._v(_vm._s(op.optionGroup.max)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        op.optionGroup.max != -1
                          ? _c("span", { staticClass: "multiple" }, [
                              _vm._v("x"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "titre" }, [
                          _vm._v(_vm._s(op.optionGroup.name)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cartItem.product.ty == 3 && _vm.nonFreeOptionGroups.length
            ? _c(
                "div",
                {
                  staticClass:
                    "modProdDetails color-grey6 shadow-2 m-20 p-20 bg-white radius-5",
                },
                [
                  _c("div", { staticClass: "display-5 text-bold mb-5" }, [
                    _vm._v("En supplément"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.nonFreeOptionGroups, function (op, i) {
                      return _c("li", { key: i }, [
                        op.optionGroup.max != -1
                          ? _c("span", { staticClass: "qty" }, [
                              _vm._v(_vm._s(op.optionGroup.max)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        op.optionGroup.max != -1
                          ? _c("span", { staticClass: "multiple" }, [
                              _vm._v("x"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "titre" }, [
                          _vm._v(_vm._s(op.optionGroup.name)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.ShopService.shop.canOrder
        ? _c(
            "div",
            {
              staticClass:
                "modal-bottom bg-white w-100 flex-center-center flex-wrap pos-sticky bottom-0 zindex-1 radius-18 px-10 py-10",
            },
            [
              _vm.product.ty != _vm.PRODUCT_TYPES.Menu
                ? _c(
                    "div",
                    { staticClass: "my-10 mx-10" },
                    [
                      _c("item-cart-qty", {
                        attrs: { "cart-item": _vm.cartItem },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.UpsellService.canUpsell(_vm.cartItem) &&
              !_vm.product.options.length
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btnFlat-color1 my-10 mx-10 flex-1 fsize-18 shadow-1 whitespace-wrap",
                      staticStyle: { "min-width": "200px" },
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          return _vm.UpsellService.upsell(_vm.cartItem)
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.UpsellService.get_upsell_info(_vm.cartItem)
                          ),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
                  staticStyle: { flex: "0 1 100%" },
                  on: {
                    click: function ($event) {
                      return _vm.selectItem(_vm.cartItem)
                    },
                  },
                },
                [
                  _c("span", [_vm._v("Ajouter")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "price text-nowrap" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ShopService.prix(
                          _vm.CartService.itemTotal(_vm.cartItem)
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }